export const routesRaporKullaniciYetki = [
  {
    path: "/rapor_kullanici_yetki",
    name: "rapor_kullanici_yetki",
    component: () => import("@/views/proje_alt/rapor_kullanici_yetki/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Kullanıcı Yetki Rapor",
      yetki: { k: [1012502] },
    },
  },
]
